import { capitalize } from "lodash";
import Toggle from "PFComponents/toggle/toggle";
import { Typography } from "PFComponents/typography";
import { FilterFamily } from "PFTypes";
import { FiltersConfigTemplateElement } from "PFTypes/filters_config";
import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";

import { Filter } from "../filter";
import { useDefaultFilterFields } from "./hooks/use_default_filter_fields";
import css from "./sections.module.scss";

type OptionalSectionProps = {
  template: FiltersConfigTemplateElement;
  filterFamily: FilterFamily | "children";
};

export const OptionalSection = ({ template, filterFamily }: OptionalSectionProps) => {
  const { control } = useFormContext();
  const defaultFilterFields = useDefaultFilterFields(template);

  const { fields, append, remove } = useFieldArray({
    control,
    name: filterFamily
  });

  const disable = () => remove(0);

  const enable = () => {
    append(defaultFilterFields);
  };

  const enabled = fields.length > 0;

  const handleToggle = () => {
    if (enabled) {
      disable();
    } else {
      enable();
    }
  };

  return (
    <div>
      <div className={css.header}>
        <Toggle onChange={handleToggle} checked={enabled} />
        <Typography variant="h2">{capitalize(filterFamily)}</Typography>
      </div>
      {enabled && (
        <div className={css.filtersList}>
          {fields.map((field, index) => (
            <Filter filterFamily={filterFamily} key={field.id} index={index} template={template} />
          ))}
        </div>
      )}
    </div>
  );
};
